import React, { useEffect } from 'react';

import { TrackingType } from '~/src/common/consumption/completion-snackbar';
import { useLocale } from '~/src/components/LocaleProvider';
import {
  CONTENT_TAG_KEY,
  ENTRY_TYPE_KEY,
  PLAYER_TYPE_KEY,
  TEACHER_FULL_NAME_KEY,
  useYouboraAnalitics,
} from '~/src/components/MediaPlayer/Youbora';

import { useMediaPlayer } from '../../MediaPlayerProvider';
import { useMediaSourceDetails } from '../../useMediaSourceDetails';
import { Content } from '../types';

export const YouboraAnalytics: React.FC<{
  trackingType?: TrackingType;
  content: Content;
  contentTag?: string | null;
}> = ({ content, contentTag, trackingType }) => {
  const { plugin } = useYouboraAnalitics();
  const { player, mediaId } = useMediaPlayer();
  const mediaDetails = useMediaSourceDetails();
  const { locale } = useLocale();

  useEffect(() => {
    if (player !== null && plugin !== null) {
      // See all options https://documentation.npaw.com/integration-docs/docs/options-video-js
      plugin?.setVideoOptions({
        'content.id': mediaId,
        'content.title': mediaDetails?.name,
        'content.duration': mediaDetails?.duration,
        'content.isLive': false,
        'content.language': locale,
        'content.type': trackingType,
        [PLAYER_TYPE_KEY]: 'MediaHeroPlayer',
        [CONTENT_TAG_KEY]: contentTag,
        [TEACHER_FULL_NAME_KEY]: content.teacher.full_name,
        [ENTRY_TYPE_KEY]: content.entry_type,
      });
    }
  }, [
    content.entry_type,
    content.teacher.full_name,
    contentTag,
    locale,
    mediaDetails,
    mediaId,
    player,
    plugin,
    trackingType,
  ]);

  return null;
};
